import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import React from 'react';
import {classy} from 'webapp-lib/utils';

type Props = {
  children?: React.ReactNode;
} & React.TableHTMLAttributes<HTMLTableCellElement>;

const UFieldPostfix = ({
  className,
  children,
  ...props
}: Props): React.ReactElement => (
  <StyledFieldPostfix
    {...props}
    className={classy({
      [className ?? '']: Boolean(className),
      FieldPostfix: true,
    })}
  >
    {children}
  </StyledFieldPostfix>
);
export const FieldPostfix = observer(UFieldPostfix);

const StyledFieldPostfix = styled.td`
  grid-area: postfix;
  align-self: center;
`;
